import PropTypes from 'prop-types';
import React from 'react';
import { ScreenReaderOnly } from 'components/misc';
import dict from 'config/dictionary';
import styles from './confirm.module.scss';
import { PrimaryButton } from '@huggg/react-components'

class Confirm extends React.Component {
  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
    this.onKeyup = this.onKeyup.bind(this);
  }

  componentDidMount() {
    window.addEventListener('keyup', this.onKeyup);
  }

  submit() {
    const { isSuperhugggEmailClaim, huggg, email, number, stash } = this.props;

    if (isSuperhugggEmailClaim) {
      stash(huggg, { email }, 'email');
    } else {
      stash(huggg, { phoneNumber: number }, 'sms');
    }
  }

  onKeyup(event) {
    const code = event.keyCode || event.which;

    if (code === 27) {
      this.props.cancel();
    }
  }

  renderControl() {
    return (
      <PrimaryButton
        className={styles.confirmButton}
        data-test-id="stash-confirm"
        disabled={this.props.stashing}
        onClick={this.submit}
        label={dict.stash.confirm.confirmButton}
      />
    )
  }

  render() {
    const {
      copy,
      error,
      huggg,
      isSuperhugggEmailClaim,
      number,
      email,
    } = this.props;

    const recipientDetail = huggg.isSuperhuggg && isSuperhugggEmailClaim ? email : number;

    return (
      <>
        <p>{copy}</p>

        <ScreenReaderOnly
          srComponent={
            <label htmlFor="confirm-recipient">
              {isSuperhugggEmailClaim ? dict.stash.confirm.recipientLabel.email : dict.stash.confirm.recipientLabel.sms}
            </label>
          }
          nonSrComponent={
            <input
              name="confirm-recipient"
              id="confirm-recipient"
              className={styles.input}
              value={recipientDetail}
              readOnly
            />
          }
        />

        {error ? (
          <p className={styles.error}>{error}</p>
        ) : null}

        {this.renderControl()}
      </>
    );
  }
}

Confirm.propTypes = {
  cancel: PropTypes.func.isRequired,
  huggg: PropTypes.object.isRequired,
  isSuperhugggEmailClaim: PropTypes.bool.isRequired,
  isSuperhugggSMSClaim: PropTypes.bool.isRequired,
  email: PropTypes.string,
  number: PropTypes.string,
  stash: PropTypes.func.isRequired,
  stashing: PropTypes.bool.isRequired,
  copy: PropTypes.string,
  error: PropTypes.string
};

export default Confirm;
